<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "./info.vue";
import Repair from "./repair.vue";
import Track from "./track.vue";
import Evaluatte from "./evaluate.vue";
export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Evaluatte,
  },
  data() {
    return {
      table: {
        mname: "work",
        key: "id",
        url: {},
        output: false,
      },
      actions: [
        // {
        //   label: '新增',
        //   icon: 'md-add',
        //   onClick: this.toAdd,
        //   auth: '',
        // },
        // {
        //   label: '导入',
        //   icon: 'md-add',
        //   onClick: this.toImport,
        //   auth: '',
        // },
        // {
        //   label: '下载模板',
        //   icon: '',
        //   onClick: this.toDownload,
        //   auth: '',
        // },
      ],
      menus: [
        // { label: '待处理', name: 'workOrder_list', auth: '' },
        // {
        //   label: '处理中',
        //   name: 'processing_list',
        //   auth: '',
        // },
        // {
        //   label: '已完成',
        //   name: 'completed_list',
        //   auth: '',
        // },
      ],
      query: {
        // state:3,
      },
      filters: [
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter : this.search,
          type: "input",
        },
        { label: "报修人", KeyEnter : this.search,name: "repairBy", value: "", type: "input" },
        { label: "工单号",KeyEnter : this.search, name: "workNo", value: "", type: "input" },
        // { label: '系统编号', name: 'facilityNo', value: '', type: 'input' },
        // {
        //   label: "时间选择",
        //   name: "start_time",
        //   value: "",
        //   type: "datetimerange",
        // },
        {
          label: "派单类型",
          name: "sendType",
          value: "",
          KeyEnter : this.search,
          type: "select",
          dropList: [
            { value: 1, name: "手动派单" },
            { value: 2, name: "自动派单" },
          ],
        },
      ],
      tableCols: [
        {
          title: "工单编号",
          key: "workNo",
          minWidth: 120,
          align: "left",
          copy: true,
        },
        {
          title: "资产编号",
          key: "facilityNum",
          minWidth: 160,
          align: "left",
          copy: true,
        },
        {
          title: "系统编号",
          key: "facilityNo",
          minWidth: 120,
          align: "left",
          copy: true,
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "资产二维码",
          key: "qrCode",
          minWidth: 120,
          align: "center",
          viewimage: true,
        },
        {
          title: "报修时间",
          minWidth: 180,
          align: "left",
          key: "repairTime",
        },
        {
          title: "维修时间",
          minWidth: 180,
          align: "left",
          key: "makeTime",
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.department;
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "派单类型",
          key: "sendType",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.sendType == 1
                ? "手动派单"
                : row.sendType == 2
                ? "自动派单"
                : "";
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "问题描述",
          key: "descr",
          width: 100,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.descr,
                  },
                },
                params.row.descr
              ),
            ]);
          },
        },
        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "待处理"
                : row.state == 2
                ? "处理中"
                : row.state == 3
                ? "已完成"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "提交时间",
          minWidth: 180,
          align: "left",
          key: "createTime",
        },
        {
          title: "报修来源",
          key: "repairSource",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource == 1
                ? "电话"
                : row.repairSource == 2
                ? "微信"
                : row.repairSource == 3
                ? "其他"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          minWidth: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              let directives = [];
              // let directives = [{ name: 'auth', value: '/admin/order/lists' }]
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toRepair(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginLeft: "5px" }}
                >
                  送修
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives = [];
              // let directives = [{ name: 'auth', value: '/admin/device/edit' }]
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toTrack(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginLeft: "5px"}}
                >
                  维修
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives = [];
              // let directives = [{ name: 'auth', value: '/admin/device/edit' }]
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginLeft: "5px" }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives = [];
              // let directives = [{ name: 'auth', value: '/admin/device/edit' }]
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEvaluate(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginLeft: "5px" }}
                >
                  评价
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.facilityNo) {
      this.query.facilityNo = query.facilityNo;
    }
    // this.loadLevelData()
    // this.loadFiltersFieldDrop('community', 'community_id')
  },
  methods: {
    // 分类
    // loadLevelData() {
    //   let q = {}
    //   $utils.api.load('serviceCategoryDropTree', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.category_id
    //         xx.name = element.name
    //         xx.children = element.children || []
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.filters.length; index++) {
    //         const element = this.filters[index]
    //         if (element && element.name == 'category_id') {
    //           // this.items[index]['dropList'] = dropList
    //           this.filters[index]['dropList'] = (this.filters[index]['dropList'] || []).concat(dropList)
    //         }
    //       }
    //     }
    //   })
    // },
    // toAdd() {
    //   $utils.url.push({ name: 'serve_add', query: { action: 'add' } })
    // },
    toRepair(row) {
      this.$Modal.success({
        closable: true,
        title: "送修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Repair
              style={{ margin: "0", color: "#19be6b" }}
              order_id={row.order_id}
            ></Repair>
          );
        },
      });
    },
    toTrack(row) {
      this.$Modal.success({
        closable: true,
        title: "维修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Track
              style={{ margin: "0", color: "#19be6b" }}
              order_id={row.order_id}
            ></Track>
          );
        },
      });
    },
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id },
      });
    },
    toDel(currentRow) {},
    toImport() {},
    toDownload() {},
    toEvaluate(row) {
      this.$Modal.success({
        closable: true,
        title: "评价",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Evaluatte
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Evaluatte>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
